import Link from "next/link";
import { useState } from "react";

export default function Menu({ transparent, scroll, pagesHeader }) {
  const [pages, setPages] = useState(pagesHeader || []);

  function getCurrentPath(id) {
    const currentPage = pages.find(item => item.id === id);
    return {
      link: currentPage?.seo_permalink,
      title: currentPage?.title
    };
  }

  return (
    <>
      <div className="navbar mr-4 flex">
        <li>
          <Link
            className={`mx-3 text-base font-medium ${
              transparent
                ? scroll
                  ? "text-pgray-600"
                  : "text-white"
                : "text-pgray-600"
            } hover:text-primary-1000`}
            href="/"
          >
            {getCurrentPath(53).title}
          </Link>
        </li>
        <li>
          <Link
            className={`mx-3 text-base font-medium ${
              transparent
                ? scroll
                  ? "text-pgray-600"
                  : "text-white"
                : "text-pgray-600"
            } hover:text-primary-1000`}
            href={"/"+ getCurrentPath(64).link??""}
          >
           {getCurrentPath(64).title}
          </Link>
        </li>
        <li>
          <Link
            className={`mx-3 text-base font-medium ${
              transparent
                ? scroll
                  ? "text-pgray-600"
                  : "text-white"
                : "text-pgray-600"
            } hover:text-primary-1000`}
            href={"/"+ getCurrentPath(66).link??""}
          >
            {getCurrentPath(66).title}
          </Link>
        </li>
        <li>
          <Link
            className={`mx-3 text-base font-medium ${
              transparent
                ? scroll
                  ? "text-pgray-600"
                  : "text-white"
                : "text-pgray-600"
            } hover:text-primary-1000`}
            href="#"
          >
            Emplois
          </Link>
        </li>
        <li>
          <Link
            className={`mx-3 text-base font-medium ${
              transparent
                ? scroll
                  ? "text-pgray-600"
                  : "text-white"
                : "text-pgray-600"
            } hover:text-primary-1000`}
            href={"/"+ getCurrentPath(61).link??""}
          >
            {getCurrentPath(61).title}
          </Link>
        </li>
        <li>
          <Link
            className={`mx-3 text-base font-medium ${
              transparent
                ? scroll
                  ? "text-pgray-600"
                  : "text-white"
                : "text-pgray-600"
            } hover:text-primary-1000`}
            href={"/"+ getCurrentPath(62).link??""}
          >
            {getCurrentPath(62).title}
          </Link>
        </li>
      </div>
    </>
  );
}
